import React, { PureComponent } from "react";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown } from "aible";
import { DropdownButton, MenuItem } from "react-bootstrap";

import { isEnabled } from "utils/featureFlags";

import { AIBLE_VIEW_TYPE } from "containers/Project/reducer";

import { isShowSharingAndAssumptions, PROJECT_MODES } from "containers/Project/reducer";
import { getIsMonitoringDemo, MONITOR_VIEW_MODES } from "containers/Monitoring/reducer";

import DatasetViewContainer from "containers/View/Dataset";
import DatasetTile from "components/Tiles/DatasetTile";

import RunItem from "containers/View/Item/RunItem";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import { LineInput } from "components/Inputs/LineInput";

import SharingIcon from "images/bSharing.svg";
import SharingIconWhite from "images/bSharing-white.svg";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const darkSelectStyle = {
  option: (provided, state) => ({
    ...provided,
    background: state.isFocused ? "#512f77" : "#362e30",
    color: "white !important"
  }),
  control: (provided) => ({
    ...provided,
    background: "#362e44",
    border: "1px solid #828282",
    color: "white !important"
    // none of react-select's styles are passed to <Control />
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "white"
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: "0px",
    paddingBottom: "0px"
  })
};

export default class ProjectHeader extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  renderAltFrontierModal() {
    const { altFrontiers, setRunId, runId } = this.props;

    const { selectedFrontier } = this.state;

    return (
      <div id={"altFrontierModal"}>
        <Dialog open={this.state.isAltFrontiers} onOpenChange={() => this.setState({ isAltFrontiers: false })}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>{"Select a Frontier"}</DialogTitle>
            </DialogHeader>
            {selectedFrontier === undefined ? (
              <div className={styles.frontierList}>
                {altFrontiers &&
                  altFrontiers.map((f, i) => (
                    <div className={styles.frontHolder} key={f.job_id + "k" + i}>
                      <div className={styles.mBadgeHolder}>
                        {f.status === "ACCEPTED" && (
                          <div
                            className={styles.mBadge}
                            style={{
                              background: "#5BCF74"
                            }}
                          >
                            {"Approved"}
                          </div>
                        )}
                        {f.job_id === runId ? (
                          <div className={styles.mBadge}>{"Viewing"}</div>
                        ) : (
                          <div className={styles.hover + " " + styles.mBadge}>{"Click to View"}</div>
                        )}
                      </div>

                      <RunItem
                        id={f.job_id}
                        isTile
                        onClick={(e) => {
                          setRunId(e);
                          return this.setState({
                            isAltFrontiers: false
                          });
                        }}
                      />
                    </div>
                  ))}
              </div>
            ) : (
              <div className={styles.chosenDataset}>
                {"Create new Frontier from this dataset: "}
                <Button
                  onClick={() =>
                    this.setState({
                      selectedFrontier: undefined
                    })
                  }
                >
                  {"Change Dataset"}
                </Button>
              </div>
            )}
            <DialogFooter>
              <Button type="secondary" onClick={() => this.setState({ isAltFrontiers: false })}>
                {"Close"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  renderDatasetModal() {
    const { datasets, dataset, createRunFromDataset, userInfoQuery } = this.props;

    const updateDataset =
      datasets &&
      this.state.updateDatasetId !== undefined &&
      datasets.filter((d) => d.id === this.state.updateDatasetId).length > 0
        ? datasets.filter((d) => d.id === this.state.updateDatasetId)[0]
        : undefined;

    return (
      <div id={"datasetModal"}>
        <Dialog open={this.state.isDataset} onOpenChange={() => this.setState({ isDataset: false })}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>{"Select a Dataset"}</DialogTitle>
            </DialogHeader>
            {updateDataset === undefined ? (
              <div className={styles.datasetList}>
                <DatasetViewContainer onClick={(d) => this.setState({ updateDatasetId: d })} />
              </div>
            ) : (
              <div className={styles.chosenDataset}>
                {"Create new Frontier from this dataset: "}
                <DatasetTile dataset={updateDataset} userInfoQuery={userInfoQuery} />
                <Button
                  onClick={() =>
                    this.setState({
                      updateDatasetId: undefined
                    })
                  }
                >
                  {"Change Dataset"}
                </Button>
              </div>
            )}
            <DialogFooter>
              <Button type="secondary" onClick={() => this.setState({ isDataset: false })}>
                {"Close"}
              </Button>

              <Button
                type="primary"
                disabled={this.state.updateDatasetId === undefined}
                onClick={() => {
                  createRunFromDataset(this.state.updateDatasetId);
                  return this.setState({
                    isDataset: false
                  });
                }}
              >
                {"Create New Frontier"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  addViewSegmentsOption(options = []) {
    const retOptions = [...options].sort((a, b) => {
      if (a.value === "Overall" || b.value === "Overall") {
        return a.value === "Overall" ? -1 : 1;
      } else {
        return a.label < b.label ? -1 : 1;
      }
    });
    retOptions.push({
      label: PROJECT_MODES.VIEW_SEGMENTS,
      value: PROJECT_MODES.VIEW_SEGMENTS
    });
    return retOptions;
  }

  handleSelectOption(option, selectHandler) {
    const { updateProjectMode } = this.props;

    if (option && option.value === PROJECT_MODES.VIEW_SEGMENTS) {
      return updateProjectMode(PROJECT_MODES.VIEW_SEGMENTS);
    } else {
      // TODO: Make that graph work
      // this.setState({mode: PROJECT_MODES.DRILLDOWN});
      updateProjectMode(PROJECT_MODES.OVERALL);
      return selectHandler(option);
    }
  }

  renderBlueprintOptions() {
    const {
      runId,
      blueprint,
      altFrontiers,
      isBlueprintLocked,
      lockBlueprint,
      disableEdit,
      isRunning,
      handleCancel,
      updateIsEditing
    } = this.props;

    return (
      <DropdownButton pullRight id="blueprint-dropdown-button" title="" style={{ margin: "3px 10px 3px 20px" }}>
        <MenuItem
          onClick={() => {
            if (isBlueprintLocked || disableEdit) {
              return;
            }
            updateIsEditing(true);
          }}
        >
          {isBlueprintLocked ? "Can't Edit Locked Blueprint" : "Edit Blueprint"}
        </MenuItem>
        {blueprint && isEnabled("export-blueprints") && (
          <MenuItem onClick={() => this.setState({ isExport: true })}>{"Export Blueprint"}</MenuItem>
        )}
        <MenuItem onClick={() => lockBlueprint(!isBlueprintLocked)}>
          {isBlueprintLocked ? "Unlock Blueprint" : "Lock Blueprint"}
        </MenuItem>
        {altFrontiers && altFrontiers.length > 1 && (
          <MenuItem onClick={() => this.setState({ isAltFrontiers: true })}>{"View Alternate Frontiers"}</MenuItem>
        )}
        {runId !== "new" && (
          <MenuItem onClick={() => this.setState({ isDataset: true })}>{"Retrain From New Dataset"}</MenuItem>
        )}
        {runId !== "new" && isRunning && <MenuItem onClick={() => handleCancel()}>{"Cancel Model Training"}</MenuItem>}
      </DropdownButton>
    );
  }

  renderInfo() {
    const { project, isDark, aibleViewType, history, selectedFolder, updateDrilldownValue, updateAibleViewType } =
      this.props;

    const isDarkMode = isDark || aibleViewType === AIBLE_VIEW_TYPE.BUSINESS;

    return (
      <div className={isDarkMode ? styles.dInfoHeader : styles.infoHeader}>
        <div
          className={styles.infoItem + " " + (isDarkMode ? styles.dInfoItem : "") + " " + styles.infoLink}
          title={selectedFolder && selectedFolder.name}
          onClick={() => history.push("/")}
        >
          {selectedFolder && selectedFolder.name ? selectedFolder.name : "My Projects"}
        </div>
        <span className={styles.chevron}>
          <FontAwesomeIcon icon={faChevronRight} />
        </span>

        <div
          className={styles.infoItem + " " + (isDarkMode ? styles.dInfoItem : "") + " " + styles.infoLink}
          title={project.name}
          onClick={() => {
            if (aibleViewType === AIBLE_VIEW_TYPE.DEPLOYMENT) {
              updateAibleViewType(AIBLE_VIEW_TYPE.BUSINESS);
            }
            return this.handleSelectOption({ label: "Summary", value: "Overall" }, (val) =>
              updateDrilldownValue(val.runId, val.value)
            );
          }}
        >
          {project.name}
        </div>
        <span className={styles.chevron}>
          <FontAwesomeIcon icon={faChevronRight} />
        </span>
      </div>
    );
  }

  render() {
    const {
      optimizer,
      optimized,
      blueprint,
      hideBlueprint,
      isDark,
      fetchMonitorData,
      isMonitorFeedback,
      isEditing,
      initJob,
      modelGroups,
      segmentOptions,
      projectMode,
      isAFO,
      isSharing,
      runId,
      setupChanged,
      updateDrilldownValue,
      aibleViewTypeOptions,
      updateAibleViewType,
      isBusinessMode,
      aibleViewType,
      monitorViewMode,
      hasSufficientData,
      updateMonitorViewMode,
      updateProjectSetting
    } = this.props;

    const { isExport } = this.state;
    const isDarkMode = isDark || aibleViewType === AIBLE_VIEW_TYPE.BUSINESS;

    const showHeaderItems =
      aibleViewType !== AIBLE_VIEW_TYPE.MONITORING && aibleViewType !== AIBLE_VIEW_TYPE.DEPLOYMENT;

    if (isEditing) {
      return null;
    }

    return (
      <div className={styles.oHeader + " " + (isDarkMode ? styles.darkMode : "")}>
        {this.renderDatasetModal()}
        {this.renderAltFrontierModal()}
        {this.renderInfo()}
        {aibleViewType !== AIBLE_VIEW_TYPE.DEPLOYMENT && (
          <div className={styles.hItem}>
            <span style={{ fontWeight: "bold" }}>{modelGroups.drilldownColumn}</span>
            <Select
              options={this.addViewSegmentsOption(segmentOptions).map((s) =>
                s.label === "Overall" ? { label: "Summary", value: "Overall" } : s
              )}
              value={
                projectMode === PROJECT_MODES.VIEW_SEGMENTS
                  ? {
                      value: PROJECT_MODES.VIEW_SEGMENTS,
                      label: PROJECT_MODES.VIEW_SEGMENTS
                    }
                  : optimizer.drilldownValue === "Overall"
                    ? { label: "Summary", value: "Overall" }
                    : {
                        value: optimizer.drilldownValue,
                        label: optimizer.drilldownValue
                      }
              }
              onChange={(v) => this.handleSelectOption(v, (val) => updateDrilldownValue(val.runId, val.value))}
              className={styles.rSelect}
              styles={isDarkMode ? darkSelectStyle : undefined}
            />
          </div>
        )}
        {aibleViewType === AIBLE_VIEW_TYPE.MONITORING && (
          <div className={styles.hMonitor}>
            <ButtonGroup>
              <Button
                active={isMonitorFeedback === false}
                onClick={() => updateProjectSetting("isMonitorFeedback", false)}
              >
                {"Overview"}
              </Button>
              <Button active={isMonitorFeedback} onClick={() => updateProjectSetting("isMonitorFeedback", true)}>
                {"Feedback"}
              </Button>
            </ButtonGroup>
            <Button
              type="primary"
              style={{ marginLeft: "10px" }}
              disabled={!hasSufficientData}
              onClick={() => {
                updateProjectSetting("isMonitorRetrain", true);
                fetchMonitorData();
              }}
            >
              {"Retrain"}
            </Button>
            {!hasSufficientData && <div style={{ marginLeft: "10px" }}>Insufficient Data for Retraining</div>}
          </div>
        )}
        <div style={{ flexGrow: 1 }} />
        {aibleViewType === AIBLE_VIEW_TYPE.ADVANCED && hideBlueprint !== true && this.renderBlueprintOptions()}
        {isExport && (
          <div className={styles.export}>
            <LineInput
              isMediumBox
              value={JSON.stringify(blueprint)}
              inputStyle={{ width: "100%" }}
              style={{ width: "100%" }}
              focus
            />
            <Button type="secondary" onClick={() => this.setState({ isExport: false })} className={styles.cancelButton}>
              {"Cancel"}
            </Button>
          </div>
        )}
        <div style={{ marginRight: "10px" }}>
          <Button
            isDark={isDarkMode}
            active={isSharing}
            onClick={() => updateProjectSetting("isSharing", !isSharing)}
            style={{ padding: "6px" }}
          >
            <img src={isDarkMode ? SharingIconWhite : SharingIcon} />
          </Button>
        </div>
        {setupChanged &&
          !isEditing &&
          runId !== "new" &&
          isDarkMode !== true &&
          aibleViewType === AIBLE_VIEW_TYPE.ADVANCED && (
            <Button
              type="primary"
              className={styles.newInputsButton}
              onClick={() => initJob()}
              style={{ marginRight: "10px" }}
            >
              {"Run With New Inputs"}
            </Button>
          )}
        {showHeaderItems && (isShowSharingAndAssumptions() || isBusinessMode) && isEnabled("aible-for-one") && (
          <div className={styles.hSelect} style={{ marginRight: "10px" }}>
            <Button
              isDark={isDarkMode}
              active={isAFO}
              onClick={() => {
                updateProjectSetting("isAFO", !isAFO);
                updateProjectSetting("isSharing", false);
                updateProjectSetting("isAssumptions", false);
              }}
              disabled={optimized.isLoading || optimized.isCreating}
            >
              {"Preview Aible for One"}
            </Button>
          </div>
        )}
        {getIsMonitoringDemo() && aibleViewType === AIBLE_VIEW_TYPE.MONITORING && (
          <ButtonGroup style={{ marginRight: "20px" }}>
            {Object.keys(MONITOR_VIEW_MODES).map((modeKey, i) => (
              <Button
                key={modeKey + i}
                active={monitorViewMode === MONITOR_VIEW_MODES[modeKey]}
                onClick={() => updateMonitorViewMode(MONITOR_VIEW_MODES[modeKey])}
              >
                {MONITOR_VIEW_MODES[modeKey]}
              </Button>
            ))}
          </ButtonGroup>
        )}
        {aibleViewTypeOptions && aibleViewTypeOptions.length > 1 && (
          <Dropdown
            onChange={({ value }) => updateAibleViewType(value)}
            options={aibleViewTypeOptions}
            selected={aibleViewType}
            isDark={isDarkMode}
          />
        )}
      </div>
    );
  }
}
